import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { siteInfo } from '../data/siteInfo';

const NotFound = () => {
  return (
  <>
    <SEO
      title={`404 — Page Not Found | ${siteInfo.companyName}`}
      description={`The page you're looking for doesn't exist. Return to the ${siteInfo.brandName} homepage.`}
    />

    <div style={{
      minHeight: '100vh',
      background: 'var(--offwhite)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'calc(var(--site-header-height) + 2.5rem) 24px 80px',
      flexDirection: 'column',
      textAlign: 'center'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* CSS House Illustration */}
        <div style={{ position: 'relative', width: '120px', height: '120px', margin: '0 auto 32px' }}>
          {/* Roof */}
          <div style={{
            position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
            width: 0, height: 0,
            borderLeft: '60px solid transparent',
            borderRight: '60px solid transparent',
            borderBottom: '50px solid var(--green)',
            filter: 'drop-shadow(0 4px 12px rgba(45,90,61,0.25))'
          }} />
          {/* Body */}
          <div style={{
            position: 'absolute', bottom: 0, left: '10px', right: '10px',
            height: '75px',
            background: 'var(--light-green)',
            borderRadius: '0 0 6px 6px'
          }} />
          {/* Door */}
          <div style={{
            position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
            width: '28px', height: '44px',
            background: 'var(--gold)',
            borderRadius: '4px 4px 0 0'
          }} />
          {/* Windows */}
          <div style={{ position: 'absolute', bottom: '28px', left: '18px', width: '20px', height: '20px', background: 'rgba(255,255,255,0.7)', borderRadius: '2px' }} />
          <div style={{ position: 'absolute', bottom: '28px', right: '18px', width: '20px', height: '20px', background: 'rgba(255,255,255,0.7)', borderRadius: '2px' }} />
        </div>

        {/* 404 */}
        <div style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(6rem, 15vw, 10rem)',
          fontWeight: 700,
          color: 'var(--gold)',
          lineHeight: 1,
          marginBottom: '16px',
          letterSpacing: '-4px'
        }}>
          404
        </div>

        <h1 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.5rem, 3vw, 2.2rem)',
          fontWeight: 600,
          color: 'var(--dark)',
          marginBottom: '12px'
        }}>
          Oops! Page Not Found
        </h1>

        <p style={{ color: '#888', fontSize: '1rem', lineHeight: 1.7, maxWidth: '440px', marginBottom: '40px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Quick Links */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '40px' }}>
          {[
            { to: '/', label: '🏠 Home', color: 'var(--green)' },
            { to: '/about', label: '👋 About', color: '#1a5fa8' },
            { to: '/services', label: '🛠️ Services', color: 'var(--gold)' },
            { to: '/contact', label: '💬 Contact', color: '#555' }
          ].map(link => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                padding: '10px 20px',
                background: '#fff',
                border: `2px solid ${link.color}`,
                borderRadius: '8px',
                color: link.color,
                fontWeight: 600,
                fontSize: '0.9rem',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => { e.currentTarget.style.background = link.color; e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = link.color; }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
          <Link to="/" className="btn-green">
            ← Back to Homepage
          </Link>
        </motion.div>
      </motion.div>
    </div>
  </>
  );
};

export default NotFound;
